define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const i18n = require('i18n');
    const _ = require('underscore');
    const Model = require('backbone').Model;
    const BaseView = require('common/base.view');

    require('widgets/autocomplete.widget');

    module.exports = BaseView.extend({
        className: 'field-control__lookup',

        options: {
            template: 'lookupControlSwissTmpl',
            label: '',
            infoTooltip: '',
            placeholder: '',
            hidden: false,
            active: true,
            innerFields: [],
            source: null,
            minLength: 2,
            visibleRows: 5,
            autocompleteClassName: '',

            // for dependent fields
            observers: []
        },

        events: {
            'focusout .fn-lookup-input-text': 'onTextFocusout',
            'keyup .fn-lookup-input-text': 'onTextKeyup'
        },

        // it will be put to model, helpful for observers
        controlType: '',

        SourceProvider: null,

        initialize: function(options) {
            this.options = { ...this.options, ...options };
            this.sourceProvider = new this.SourceProvider();

            this.model = new Model({
                loadingLocks: [],
                searchResult: null,
                controlType: this.controlType,
                hidden: this.options.hidden,
                showInnerFields: !this.sourceProvider.enabled,
                disableInnerFields: this.sourceProvider.enabled
            });
        },

        subscribe: function() {
            this.listenTo(this.model, 'change', this.notify);
            this.listenTo(this.model, 'change:selectedItem', this.onChangeSelectedItem);
            this.listenTo(this.model, 'change:searchResult', this.onChangeSearchResult);
            this.listenTo(this.model, 'change:loadingLocks', this.onChangeLoadingLocks);
            this.listenTo(this.model, 'change:hidden', this.onChangeHidden);
            this.listenTo(this.model, 'change:showInnerFields', this.onChangeShowInnerFields);
            this.listenTo(this.model, 'change:disableInnerFields', this.onChangeDisableInnerFields);
        },

        notify: function(model) {
            this.options.observers
                .filter(Boolean)
                .forEach((observer) => observer.update(model));
        },

        /**
         * @param model
         */
        // eslint-disable-next-line no-unused-vars
        update: function(model) {},

        // region DOM Events
        onTextFocusout: function() {
            this.$el.find('.fn-lookup-input-text').val('');
        },

        onTextKeyup: function(event) {
            if (event.key === 'Enter') {
                event.stopPropagation();
            }
        },
        // endregion

        // region Model Events
        onChangeSelectedItem: function() {
            const selectedItem = this.model.get('selectedItem');

            if (!selectedItem) {
                return;
            }

            this.$('.fn-lookup-input-text').val(this.sourceProvider.format(selectedItem));
            this.$('.fn-lookup-inner').forEach((field) => {
                const $inputs = $(field).find('input');
                const value = selectedItem[field.dataset.name];

                if (value) {
                    $inputs.val(value);
                    $(field).removeClass('fn-validate');
                }
            });
        },

        onChangeLoadingLocks: function() {
            const locks = this.model.get('loadingLocks');
            const isLoading = Boolean(locks.length);

            this.$('.fn-lookup-input-text').toggleClass('progress__lookup', isLoading);
        },

        onChangeHidden: function() {
            const hidden = this.model.get('hidden');
            const $fieldsContainer = this.$('.fn-fields-container');

            $fieldsContainer.toggleClass('address-lookup-hidden', hidden);
        },

        onChangeShowInnerFields: function() {
            const showInnerFields = this.model.get('showInnerFields');

            const $lookup = this.$('.fn-lookup');
            const $lookupInput = this.$('.fn-lookup-input-text');
            const $innerFields = this.$('.fn-lookup-inner');

            $lookup.toggleClass('address-lookup-hidden', showInnerFields);
            $lookupInput.toggleClass('no-validate', showInnerFields);
            $innerFields.toggleClass('address-lookup-hidden', !showInnerFields);
        },

        onChangeDisableInnerFields: function() {
            const disableInnerFields = this.model.get('disableInnerFields');

            const $innerFields = this.$('.fn-lookup-inner');
            const $lookupInnerTextInputs = this.$('.fn-lookup-inner-input-text');
            const $lookupInnerHiddenInputs = this.$('.fn-lookup-inner-input-hidden');

            $lookupInnerTextInputs.toggleClass('inner-field-disabled', disableInnerFields);
            $lookupInnerHiddenInputs.toggleClass('inner-field-disabled', !disableInnerFields);

            if (disableInnerFields) {
                $innerFields.removeClass('fn-validate');
                $lookupInnerTextInputs.attr('disabled', 'disabled').attr('autocomplete', 'off');
                $lookupInnerHiddenInputs.removeAttr('disabled');
            } else {
                $innerFields.addClass('fn-validate');
                $lookupInnerTextInputs.removeAttr('disabled').attr('autocomplete', 'on');

                $lookupInnerHiddenInputs.forEach(hiddenField => {
                    $(hiddenField).attr('disabled', 'disabled');

                    if (hiddenField.value) {
                        this.options.form.validateField(hiddenField.closest('.fn-lookup-inner'));
                    }
                });
            }
        },

        onChangeSearchResult: function() {
            let searchResult = this.model.get('searchResult');

            if (Array.isArray(searchResult)) {
                searchResult = searchResult.map((item) => this.sourceProvider.format(item));
            }

            this.$el
                .find('.fn-lookup-input-text')
                .autocomplete('setResult', searchResult);
        },
        // endregion

        handleSelectItem: function(index) {
            const prevSelectedItem = this.model.get('selectedItem');
            const nextSelectedItem = this.model.get('searchResult')[index];

            this.model.set({
                showInnerFields: Boolean(this.options.innerFields),
                selectedItem: nextSelectedItem
            });

            // should trigger change in any case
            if (_.isEqual(prevSelectedItem, nextSelectedItem)) {
                this.model.trigger('change:selectedItem');
            }
        },

        handleSearchResult: function(result) {
            if (result.errorCode) {
                return this.handleSearchError(result);
            }

            this.model.set({
                searchResult: result
            });

            if (!result.length) {
                this.showError(i18n.t('playtech.mobile.registration.addressLookupSwiss.serviceError.noResults'));

                return;
            }

            const prevResult = this.model.get('searchResult');

            this.options.form.resetField(this.$('.fn-lookup'));

            // should trigger change in any case if exist
            if (_.isEqual(prevResult, result)) {
                this.model.trigger('change:searchResult');
            }
        },

        handleSearchError: function(error) {
            const { errorCode, errorMessage } = error;

            if (errorCode === this.sourceProvider.ABORT_ERROR) {
                this.model.set({
                    searchResult: null
                });

                return;
            }

            this.model.set({
                searchResult: []
            });

            const defaultError = i18n.t('playtech.mobile.registration.addressLookupSwiss.serviceError.default');
            const errorTK = errorCode === this.sourceProvider.NOT_VALID_ERROR
                ? this.getValidationError()
                : 'playtech.mobile.registration.addressLookupSwiss.serviceError.' + errorCode;
            const message = i18n.tExt(errorTK, errorMessage || defaultError);

            this.showError(message);
        },

        search: function(value) {
            const prevSearchResult = this.model.get('prevSearchResult');
            const setResult = this.handleSearchResult.bind(this);
            const hideLoading = this.showLoading();

            this.sourceProvider.search(value, prevSearchResult)
                .then(setResult, setResult)
                .finally(hideLoading);
        },

        getValidationError: function() {
            return 'playtech.mobile.registration.addressLookupSwiss.serviceError.validation';
        },

        showLoading: function() {
            const lockId = window.Symbol('loadingLock');
            const loadingLocks = this.model.get('loadingLocks');

            this.model.set('loadingLocks', [...loadingLocks, lockId]);

            return () => {
                const locks = this.model.get('loadingLocks');

                this.model.set('loadingLocks', locks.filter((id) => id !== lockId));
            };
        },

        showError: function(message) {
            this.options.form.setFieldInvalid(this.$('.fn-lookup'), { message: message });
        },

        render: function() {
            const renderOptions = this.prepareRenderOptions();

            this.$el.html(this.tmpl(this.options.template, renderOptions));

            if (this.sourceProvider.enabled) {
                this.attachWidget(this.$el.find('.fn-lookup-input-text').autocomplete({
                    search: this.search.bind(this),
                    onSelect: this.handleSelectItem.bind(this),
                    minLength: this.options.minLength,
                    visibleRows: this.options.visibleRows,
                    className: this.options.autocompleteClassName,
                    collapseOnSelect: false,
                    collapseOnScroll: false
                }));
            }

            return this;
        },

        prepareRenderOptions: function() {
            const hidden = this.model.get('hidden');
            const showInnerFields = this.model.get('showInnerFields');
            const disableInnerFields = this.model.get('disableInnerFields');
            const { innerFields, ...options } = this.options;

            return {
                ...options,
                hidden,
                showInnerFields,
                disableInnerFields,
                controlType: this.controlType,
                innerFields: innerFields.map((config) => ({
                    ...config,
                    showInnerFields,
                    disableInnerFields
                }))
            };
        },

        reset: function() {
            const form = this.options.form;

            this.$el.find('.fn-lookup, .fn-lookup-inner').forEach((field) => {
                const $field = $(field);

                $field.find('input').forEach((input) => {
                    input.value = '';
                    $(input).trigger('input');
                });

                form.resetField($field);
            });

            this.model.set({
                selectedItem: null,
                searchResult: null,
                prevSearchResult: null,
                hidden: this.options.hidden,
                showInnerFields: !this.sourceProvider.enabled,
                disableInnerFields: this.sourceProvider.enabled
            });
        },

        enableManualInput: function() {
            this.model.set({
                hidden: false,
                showInnerFields: true,
                disableInnerFields: false
            });
        }

    });

});
